import React, {PropTypes} from "react";
import Tooltip from "react-bootstrap/lib/Tooltip";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Modal from "react-bootstrap/lib/Modal";
import axios from "axios";
import moment from "moment";
import PersonalForm from "../common/forms/PersonalForm";
import DogFoodingModal from "./DogFoodingModal";
import Constants from "../../classes/constants"
import {hashHistory }from 'react-router';


class Maininfo extends React.Component {

  constructor() {
    super();
    //this.props.keys = ["name","Doj"];
    this.tablerow = this.tablerow.bind(this);
    this.returnkeys = this.returnkeys.bind(this);
    this.close = this.close.bind(this);
    this.closeEdit = this.closeEdit.bind(this);
    this.openEdit = this.openEdit.bind(this);
    this.state = {
      showEdit: false, employee_data: "",
      dogFooding: false,
      status: "inactive",
      image_link: "", src: "", name: "", photo: "/public/images/logo.png", error: 0, showDialog: false, profilePic:Constants.defaultProfilePicture[0]
    };
    this.closeDogFooding = this.closeDogFooding.bind(this);
  }

  closeDogFooding() {
    this.setState({dogFooding: false})
  }

  closeEdit() {
    this.setState({showEdit: false});
  }

  openEdit() {
    this.setState({showEdit: true})
  }

  close() {
    this.setState({showDialog: false})
  }

  componentDidMount() {
    if(this.props.emp.imageUrl){
        this.setState({profilePic: this.props.emp.imageUrl});
        this.setState({src: this.props.emp.imageUrl});
    }else{
      this.setState({profilePic: Constants.defaultProfilePicture[0]});
      this.setState({src: Constants.defaultProfilePicture[0]});
    }

    let checkInTime = localStorage.getItem("checkInTime");
    let date = new Date().toISOString();

    if(checkInTime==null ) {

      axios.get(process.env.REQ_URL + "/attendance/checkInTime", {
        withCredentials: true,
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      }).then((response)=> {
        localStorage.setItem("checkInTime", response.data.data.checkInTime);
        this.setState({time: response.data.data.checkInTime});
      }).catch((error) => {

      });
    }
    else if (date.substr(0,10) !=  checkInTime.substr(0,10))
    {
      axios.get(process.env.REQ_URL + "/attendance/checkInTime", {
        withCredentials: true,
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      }).then((response)=> {
        localStorage.setItem("checkInTime", response.data.data.checkInTime);
        this.setState({time: response.data.data.checkInTime});
      }).catch((error) => {

      });
    }
      else
        this.setState({time: localStorage.getItem("checkInTime")});
  }

  componentWillReceiveProps(nextProps) {
        if(nextProps.emp.imageUrl){
          this.setState({profilePic: nextProps.emp.imageUrl});
        }else{
          this.setState({profilePic: Constants.defaultProfilePicture[0]});
        }
  }



  returnkeys(index) {
    let keys = ["name", "empno", "doj", "rep", "cont"];
    return keys[index];

  }


  tablerow(data, index) {
    if (this.returnkeys(index + 1) != 'doj')
      return (<tr key={index}>
        <td width="38%">{data}</td>
        <td width="10%">:</td>
        <td width="52%">{this.props.emp[this.returnkeys(index + 1)]}</td>
      </tr>)

    return (<tr key={index}>
      <td width="38%">{data}</td>
      <td width="10%">:</td>
      <td width="52%">{moment(this.props.emp[this.returnkeys(index + 1)]).format('DD-MM-YYYY')}</td>
    </tr>);
  }

  render() {
    const initialValues = {
      initialValues: {
        emailId: this.props.emp.perEmail,
        contactNo: this.props.emp.cont
      }
    }

    let fields = ["Employee Code", "Date of joining", "Reporting to", "Contact No"];
    const name = this.props.emp;
    const field = this.props.emp.empno;
    const photo = "http://192.168.101.88:3333/public/profile/" + field + ".jpg";

    return (
      <div>
        <div className="wrapper-1 margin-minus">
          <div className="row clearfix">
            <div className="col-md-7 col-lg-8">
              <div style={{display: 'none'}}>
              </div>
              <div className="clearfix">
                <div className="profile-pic-placeholder pull-left">
                  <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Change Profile Photo</Tooltip>}>
                    <img
                      className="hand"
                      onClick={()=> {
                        this.setState({showDialog: true})
                      }}
                      src={this.state.profilePic}
                      onError={()=> {
                        this.setState({error: this.state.error + 1})
                      }} height="160px" width="155px"/>
                  </OverlayTrigger>

                </div>
                <div className="profile-pic-info pull-left">
                  <h1 style={{marginTop: 0}}><a style={{color: '#616161'}} href={"#/1/profile/" + field}>{name.name}</a>
                  </h1>
                  <table className="table" width="100%" cellPadding={0} cellSpacing={0}>
                    <tbody>
                    {fields.map(this.tablerow)}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-5 col-lg-4 hrms-button">
              <a onClick={()=> {
                this.props.openAttendance();
              }} style={{width: '300px'}} className="sec-link">
                <i className="glyphicon glyphicon-time"></i>
                <font style={{fontSize: '16px'}}>
                  Check In Time: {this.state.time != null ? this.state.time.substr(11, 8) : 'NA'}</font></a>
            </div>

            <DogFoodingModal open={this.state.dogFooding}
                             close={this.closeDogFooding}/>

            <Modal
              show={this.state.showEdit} onHide={this.closeEdit}>
              <Modal.Header closeButton>
                <Modal.Title>Edit Personal Info</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <PersonalForm {...initialValues}/>
                &nbsp;
              </Modal.Body>
            </Modal>

            <Modal show={this.state.showDialog} onHide={this.close}>
              <Modal.Header closeButton>
                <Modal.Title>Change Profile Photo</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img
                  src={this.state.src}
                  height="200px" width="200px" border={0}/>
                <form action={"upload/" + field} method="post" encType="multipart/form-data" id="uploadForm">
                  <input
                    onChange={(event)=> {
                    let file_size = event.target.files[0].size;
                    if(file_size > Constants.imageSize) {
                        alert('Image size is too big. Please upload a small size image');
                    }else{
                      var reader = new FileReader();
                      reader.onload = (e)=> {
                        this.setState({src: e.target.result})
                      };
                      reader.readAsDataURL(event.target.files[0]);
                      this.setState({file: event.target.files[0]})
                    }}}
                    type="file" accept=".jpg" name="avatar" id="avatar"/>
                  <button className="btn btn-primary" type="button"
                          onClick={(e)=> {
                            e.preventDefault();
                            let data = new FormData();
                            data.append('picture', this.state.file, field + ".jpg");
                            let xhr = new XMLHttpRequest();
                            xhr.open('POST', process.env.REQ_URL +'/upload', true);
                            xhr.responseType = 'json';
                            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                            xhr.withCredentials = true;

                            // Set up a handler for when the request finishes.
                            xhr.onload = function () {
                              if (xhr.status === 200) {
                                this.setState({showDialog: false, error: 0, profilePic: xhr.response.data})
                                // File(s) uploaded.
                              } else {
                                alert('An error occurred!');
                              }
                            }.bind(this);
                            xhr.send(data);
                          }}
                  >
                    Upload Profile Photo
                  </button>

                </form>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>

    );

  }

}
Maininfo.propTypes = {
  emp: React.PropTypes.object.isRequired
};
export default  Maininfo;





/** WEBPACK FOOTER **
 ** ./src/components/Home/Maininfo.js
 **/